module.exports = __webpack_public_path__ + "assets/radio.1db061a7.svg";